<template>
    <div>

        <div ref="paypal"></div>

    </div>
</template>

<script>
import {storePayment} from '@/api/payment'
export default {
  data () {
    return {
                
    }
  },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://www.paypal.com/sdk/js?client-id=ATo98aPwA_aCJTVw63Fhf-m8J-EB8NzVwlbIDA-TiHLZQiHzP12mlEeOnDws-AZy9IizLwCdfeOX6qgn'
    script.addEventListener('load', this.setLoaded)
    document.body.appendChild(script)

  },
  methods: {
    setLoaded () {

      const vm = this
        
      window.paypal
        .Buttons({
          createOrder:(data, actions) => {
            return actions.order.create({
              purchase_units:[
                {
                  description:'Description part',
                  amount:{
                    currency_code:'USD',
                    value:0.1
                  }
                }
              ]
            })
          },
          onApprove (data, actions) {

            
            
            
            // This function captures the funds from the transaction.
            return actions.order.capture().then(function (details) {
              
              // This function shows a transaction success message to your buyer.
              alert(`Transaction completed by ${  details.payer.name.given_name}`)
              if (details) {
                vm.savePayment(details)
              }
            })
          }
        }).render(this.$refs.paypal)
    },
    async savePayment (paymentData) {

      const payload = {
        'jsonData':paymentData,
        'platform_module_id' :1,
        'platform_module':'Course',
        'entity_id': 407//couse_id
      }

      const data = await storePayment(localStorage.getItem('customer_id'), payload)
      

    }
  }
}
</script>

<style lang="scss" scoped>

</style>